import { Divider, Space } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import Title from "antd/lib/typography/Title";

const AboutKD = () => {
  return (
    <>
      <Space direction="horizontal" style={{ width: "100%", justifyContent: "center" }}>
        <Title>Om oss</Title>
      </Space>
      <Divider />

      <Paragraph style={{ fontSize: "1.1em" }}>
        KarriereDagene har siden 2004 blitt arrangert av studenter ved linjen industriell økonomi og teknologiledelse på
        NTNU. Bindeleddet NTNU står bak planleggingen av arrangementet, som gjennomføres i samarbeid med 4. klasse. Det
        som begynte som en liten jobbmesse i Glassgården med 24 bedrifter har etter hvert vokst til å bli Norges største
        med over 150 bedrifter på Frimerket, midt i hjertet av Campus Gløshaugen.
      </Paragraph>
      <Title level={3}>Struktur</Title>
      <Paragraph style={{ fontSize: "1.1em" }}>
        Prosjektgruppen bak KarriereDagene NTNU består av 12 medlemmer. Medlemmene er fordelt på ulike ansvarsområder
        innen bedriftskontakt, messehall, markedsføring, event og IT. I tillegg til disse medlemmene bidrar
        fjerdeklassinger fra Indøk med å rigge opp messehallen, markedsføre KarriereDagene og arrangere eventer.
      </Paragraph>
    </>
  );
};

export default AboutKD;
